<div>
  @if (addDocumentType() === addDocumentTypeEnum.FromDocumentMinotaure) {
    @if (signedOnly()) {
      <oui-banner declination="info" title="Seuls les documents signés sont proposés." [showCloseButton]="false"></oui-banner>
    }
    @if (documents().length > 0) {
      <app-documents-table
        #documentsTableComponent
        [documents]="documents()"
        [isAddDocumentSignatureTable]="true"
        [singleSelection]="singleSelection()">
      </app-documents-table>
    } @else {
      <oui-etat-vide
        [title]="'Aucun document disponible'"
        icon="unknown_document">
      </oui-etat-vide>
    }
  } @else if (addDocumentType() === addDocumentTypeEnum.FromLocalFolder) {
    <app-add-document-form
      #addDocumentFormComponent
      [isSignatureDocument]="true"
      [excludedDocumentTypeCodes]="excludedDocumentTypeCodes()">
    </app-add-document-form>
  }
</div>
